import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AISvg from 'components/shared/svg/AISvg';

const AddTextSpaceBelow = ({ lessonText, onLessonTextChange }) => {
  return (
    <div className="add-space-below">
      <div className="mb-8">
        <Text variant={TEXT_VARIANTS.TITLE}>
          <AISvg className="generate-svg" />
          {t('actions.lesson_generate_modal.add_text_space_below')}
        </Text>
      </div>
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
          {t('actions.lesson_generate_modal.best_results')}
        </Text>
      </div>
      <textarea
        className="LessonGenerateModal--textarea NewInput NewInput--white NewInput--fw"
        onChange={onLessonTextChange}
        rows="10"
        value={lessonText}
        placeholder={t(
          'actions.lesson_generate_modal.copy_and_paste_placeholder',
        )}
      />
    </div>
  );
};

export default AddTextSpaceBelow;
